<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .user -->
    <b-form-group
      id="input-group-1"
      :label="$t('attendance.user')"
      label-for="input-1"
    >
      <Select2
        id="input-1"
        v-model="newItem.user"
        :options="userOptions"
      />
    </b-form-group>        <!-- .sign_in_time -->
    <b-form-group
      id="input-group-2"
      :label="$t('attendance.sign_in_time')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.sign_in_time"
        type="text"
        :placeholder="$t('attendance.sign_in_time')"
      />
    </b-form-group>
    <!-- .sign_out_time -->
    <b-form-group
      id="input-group-3"
      :label="$t('attendance.sign_out_time')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.sign_out_time"
        type="text"
        :placeholder="$t('attendance.sign_out_time')"
      />
    </b-form-group>
    <!-- .attendance -->
    <b-form-group
      id="input-group-4"
      :label="$t('attendance.attendance')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.attendance"
        type="text"
        :placeholder="$t('attendance.attendance')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/AttendanceController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'AttendanceForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      user: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
